var React = require('react');

function Keynote (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M368 448h-80v-64h-64v64h-80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM206.68 82.45A47.73 47.73 0 0 0 240 96h64a48 48 0 0 0 0-96h-64a47.89 47.89 0 0 0-46.31 36C137.77 49.72 96 99.91 96 160h48c0-37.62 26.21-69.06 62.68-77.55z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M508.62 281.24a32.07 32.07 0 0 1 3.38 14.31V320a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32v-24.45a32 32 0 0 1 3.38-14.31l51.78-103.55A32 32 0 0 1 83.78 160h344.44a32 32 0 0 1 28.62 17.69z","className":"fa-primary","key":2})]);
}

Keynote.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Keynote;

Keynote.default = Keynote;
